import React, { useState, useContext } from "react";
import { Modal } from "antd";
import logo from "../../../Assets/Images/logo.png";
import WebMyAccountProvider from "../../../Provider/WebMyAccountProvider";
const LoginPopup = () => {
  const {
    webLoginPopup,
    setWebLoginPopup,
    webLoginSteps,
    webLoginStepOneLoaderV2,
    fetchWebLoginStepOneV2,
  } = useContext(WebMyAccountProvider);
  const [phone, setPhone] = useState("");





  return (
    <>
      <Modal
        open={webLoginPopup}
        header={null}
        footer={null}
        closable={true}
        maskClosable={true}
        width={380}
        onCancel={() => setWebLoginPopup(false)}
      >
        <div className="login_popup">
          <img src={logo} alt="Nattu Logo" />
          {webLoginSteps === 1 && (
            <>
              <p className="label_mob">Enter Mobile Number</p>
              <div className="mob_no_align">
                <div>+91</div>
                <input
                  type="text"
                  placeholder=""
                  name="mobile_number"
                  maxLength={10}
                  value={phone}
                  onChange={(e) => setPhone(e.target.value)}
                  className="mob_no_input"
                />
              </div>
              <button
                type="primary"
                htmlType="button"
                className="step_one"
                onClick={() => fetchWebLoginStepOneV2(phone)}
              >
                {webLoginStepOneLoaderV2 ? "Processing..." : "Submit"}
              </button>
            </>
          )}
          <p className="privacy_policy">
            By proceeding, I accept that I have read and understood the
            Naatusakkarai’s <a>Privacy Policy</a> and <a>T&C</a>
          </p>
        </div>
      </Modal>
    </>
  );
};

export default LoginPopup;
